<template>
  <div>
    <h2 class="el_h2">用户修改密码</h2>
    <!-- 修改密码 -->
    <el-form
    ref="password_form"
    :model="password_form"
    label-width="80px"
    class="password_form"
    :rules="rules"
    >
      <el-form-item label="用户名">
        <el-input :readonly="true" v-model="userName"></el-input>
      </el-form-item>
      <el-form-item label="原始密码" prop="passWord">
        <el-input show-password type="password" placeholder="请输入原始密码" v-model="password_form.passWord"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassWord">
        <el-input show-password type="password" placeholder="请输入新密码" v-model="password_form.newPassWord"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit_form()">提交</el-button>
        <el-button @click="reset_form()">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {isPwd} from '../../../static/validate.js'
  export default {
    data() {
      let validatePwd =(rule, value, callback)=>{
        if(!isPwd(value)){
          callback(new Error('密码格式错误,不允许空格存在'))
        }else{
          callback()
        }
      }
      return{
        //用户名
        userName:localStorage.getItem('userName'),
        //修改密码表单
        password_form:{
          passWord:'',
          newPassWord:''
        },
        //表单验证
        rules:{
          passWord:[
            {required:true,message:'请输入原始密码',trigger:'blur'},
            {validator:validatePwd,trigger:'blur'}
          ],
          newPassWord:[
            {required:true,message:'请输入新密码',trigger:'blur'},
            {validator:validatePwd,trigger:'blur'}
          ]
        }
      }
    },
    created() {
      this.publicAjax.axios_set()
    },
    mounted() {

    },
    methods:{
      //修改密码
      submit_form(){
        let that=this
        that.$refs['password_form'].validate((valid)=>{
          if(valid){
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/user/changePwd',
              data:that.password_form,
              headers:{
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
                that.$refs['password_form'].resetFields()
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            return false
          }
        })
      },
      //重置表单
      reset_form(){
        this.$refs['password_form'].resetFields()
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .password_form{
    width: 60%;
  }
  @media  screen and (max-width:720px) {
    .password_form{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/change_password.vue